const STANDARD_WHITE_1 = {
  url: 'https://res.insta360.com/static/d28515b2cc88bfaad852903afbd5eea0/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@2x.jpeg',
  urlL: 'https://res.insta360.com/static/4965ed39e6214f350d7ec28a37c5d9bf/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD.jpeg',
  url_m:
    'https://res.insta360.com/static/d28515b2cc88bfaad852903afbd5eea0/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@2x.jpeg',
  url_s:
    'https://res.insta360.com/static/b816a37166b8f2782af5fdd754a702dc/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@2x-1.jpeg',
};
const STANDARD_BLACK_1 = {
  url: 'https://res.insta360.com/static/cc764f8b357f26ddfead7ec4a8f9857f/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@2x.jpeg',
  urlL: 'https://res.insta360.com/static/e8351459463f103d50c4223b36afff0f/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91.jpeg',
  url_m:
    'https://res.insta360.com/static/cc764f8b357f26ddfead7ec4a8f9857f/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@2x.jpeg',
  url_s:
    'https://res.insta360.com/static/2aaa27805d7d0a8ae3dda14341262c9c/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@2x-1.jpeg',
};
const STANDARD_2 = {
  url: 'https://res.insta360.com/static/a7cb11926ac4de33fa2190909da85560/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@2x.jpeg',
  urlL: 'https://res.insta360.com/static/84e5278aa37323f2c1e398bcf532b229/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002.jpeg',
  url_m:
    'https://res.insta360.com/static/a7cb11926ac4de33fa2190909da85560/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@2x.jpeg',
  url_s:
    'https://res.insta360.com/static/2275d219b1bfda95fe265cc7388a4593/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@2x-1.jpeg',
};
const STANDARD_3 = {
  url: 'https://res.insta360.com/static/9d8e5699201d9ee329b4d394859e1ecf/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@2x.jpeg',
  urlL: 'https://res.insta360.com/static/515f719342831d7b8aed021c8b76e747/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003.jpeg',
  url_m:
    'https://res.insta360.com/static/9d8e5699201d9ee329b4d394859e1ecf/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@2x.jpeg',
  url_s:
    'https://res.insta360.com/static/715eb4159c3179b8f288aed47afe74c0/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@2x-1.jpeg',
};
const STANDARD_4 = {
  url: 'https://res.insta360.com/static/db2bf755787212684470d100b0dedf43/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@2x.jpeg',
  urlL: 'https://res.insta360.com/static/e8243b84119b6926065e8f20a16563c5/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004.jpeg',
  url_m:
    'https://res.insta360.com/static/db2bf755787212684470d100b0dedf43/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@2x.jpeg',
  url_s:
    'https://res.insta360.com/static/5b68fbd835dfdfb6bcec6fecab4fe6f1/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@2x-1.jpeg',
};
const FAMILY_WHITE_1 = {
  url: 'https://res.insta360.com/static/ba91361a36dfea714f17d9a94a3b287e/01@2x%202.jpeg',
  urlL: 'https://res.insta360.com/static/58d453e4a7ddde7124a67c3ccc005115/01.jpeg',
  url_m: 'https://res.insta360.com/static/ba91361a36dfea714f17d9a94a3b287e/01@2x%202.jpeg',
  url_s: 'https://res.insta360.com/static/2e023a7c4778f6c70e188fe55b33f7a7/01@2x-1%202.jpeg',
};
const FAMILY_BLACK_1 = {
  url: 'https://res.insta360.com/static/06aeaf542b8def7b32832e22dbcc6cf6/02-%E9%BB%91@2x.jpeg',
  urlL: 'https://res.insta360.com/static/0130f4e09c634a27430cc8cb3bfc88fb/02-%E9%BB%91.jpeg',
  url_m: 'https://res.insta360.com/static/06aeaf542b8def7b32832e22dbcc6cf6/02-%E9%BB%91@2x.jpeg',
  url_s: 'https://res.insta360.com/static/901e10173addca141457ff5eeab1de6f/02-%E9%BB%91@2x-1.jpeg',
};
const FAMILY_2 = {
  url: 'https://res.insta360.com/static/e3e9df5159cada7b9852d11839b52547/03@2x.jpeg',
  urlL: 'https://res.insta360.com/static/14f93727cdc527a29d806d1af0a7d873/03.jpeg',
  url_m: 'https://res.insta360.com/static/e3e9df5159cada7b9852d11839b52547/03@2x.jpeg',
  url_s: 'https://res.insta360.com/static/32c05b41f59a862d815428b28ec3c329/03@2x-1.jpeg',
};
const FAMILY_3 = {
  url: 'https://res.insta360.com/static/537e0c6d87c82c780601547c365aded1/04@2x.jpeg',
  urlL: 'https://res.insta360.com/static/061fc7eb1320e22535358bb243ff2c2a/04.jpeg',
  url_m: 'https://res.insta360.com/static/537e0c6d87c82c780601547c365aded1/04@2x.jpeg',
  url_s: 'https://res.insta360.com/static/36df3a7acce4ea31333ec4afa7d8c2f8/04@2x-1.jpeg',
};
const FAMILY_4 = {
  url: 'https://res.insta360.com/static/f6876af1f5d762975cf05e20e7d30b0b/05@2x.jpeg',
  urlL: 'https://res.insta360.com/static/9e9ad990f0e4e97b1b2a9347fab8ead6/05.jpeg',
  url_m: 'https://res.insta360.com/static/f6876af1f5d762975cf05e20e7d30b0b/05@2x.jpeg',
  url_s: 'https://res.insta360.com/static/db8035dda48906f7096a9906ee63df35/05@2x-1.jpeg',
};
const ULTIMATE_WHITE_1 = {
  url: 'https://res.insta360.com/static/920c2ec550a24a20576f96f6891be2cc/01@2x.jpeg',
  urlL: 'https://res.insta360.com/static/0c0a2842181f755e8de4cd3c33522f3e/01.jpeg',
  url_m: 'https://res.insta360.com/static/920c2ec550a24a20576f96f6891be2cc/01@2x.jpeg',
  url_s: 'https://res.insta360.com/static/8b62a0c37db80c13a6cc31857b5ad8fd/01@2x-1.jpeg',
};
const ULTIMATE_BLACK_1 = {
  url: 'https://res.insta360.com/static/2e70ab06dbae12c4c7d9735025b2100c/02-%E9%BB%91@2x.jpeg',
  urlL: 'https://res.insta360.com/static/d310c83e4141860194104e6a12614589/02-%E9%BB%91.jpeg',
  url_m: 'https://res.insta360.com/static/2e70ab06dbae12c4c7d9735025b2100c/02-%E9%BB%91@2x.jpeg',
  url_s: 'https://res.insta360.com/static/02a49dc0c7f364bb1e00241c1e0e9291/02-%E9%BB%91@2x-1.jpeg',
};
const ULTIMATE_2 = {
  url: 'https://res.insta360.com/static/2a983719cb1f6b59d8b24723e5b691c7/03@2x.jpeg',
  urlL: 'https://res.insta360.com/static/1002a2ba0d3b04120a5218c0ead9a121/03.jpeg',
  url_m: 'https://res.insta360.com/static/2a983719cb1f6b59d8b24723e5b691c7/03@2x.jpeg',
  url_s: 'https://res.insta360.com/static/4ae5648c33af12377043559ac5c09f4c/03@2x-1.jpeg',
};
const ULTIMATE_3 = {
  url: 'https://res.insta360.com/static/3b7b1b427440691d1e6f7d49d7e5f0f1/04@2x.jpeg',
  urlL: 'https://res.insta360.com/static/d1ae4183bab65f1af3d565e01f73b859/04.jpeg',
  url_m: 'https://res.insta360.com/static/3b7b1b427440691d1e6f7d49d7e5f0f1/04@2x.jpeg',
  url_s: 'https://res.insta360.com/static/a2870dff54a1366d8a7568fabf41b784/04@2x-1.jpeg',
};
const ULTIMATE_4 = {
  url: 'https://res.insta360.com/static/192649aa11b2472713e60ae5a0a9b11e/05@2x.jpeg',
  urlL: 'https://res.insta360.com/static/1e809a7c485a2e1c23d7644a759968bb/05.jpeg',
  url_m: 'https://res.insta360.com/static/192649aa11b2472713e60ae5a0a9b11e/05@2x.jpeg',
  url_s: 'https://res.insta360.com/static/c096ab6c8fabf17327c13227dc0afa4b/05@2x-1.jpeg',
};

const ACTION_WHITE_1 = {
  url: 'https://res.insta360.com/static/ec22edf85403cd8097bdaeecd66e4860/01@2x.jpeg',
  urlL: 'https://res.insta360.com/static/73d6c0783ee4d1aea37f1c3a11c39c1f/01.jpeg',
  url_m: 'https://res.insta360.com/static/ec22edf85403cd8097bdaeecd66e4860/01@2x.jpeg',
  url_s: 'https://res.insta360.com/static/1f7750de2affc5eb1009a0cbd209d264/01@2x-1.jpeg',
};
const ACTION_BLACK_1 = {
  url: 'https://res.insta360.com/static/432b5be07ea05154f92138af0a127dff/02-%E9%BB%91@2x.jpeg',
  urlL: 'https://res.insta360.com/static/b5728befe402c3c6d73f47121ed80720/02-%E9%BB%91.jpeg',
  url_m: 'https://res.insta360.com/static/432b5be07ea05154f92138af0a127dff/02-%E9%BB%91@2x.jpeg',
  url_s: 'https://res.insta360.com/static/bc5e39fbdc2d06f991c0594c101130e8/02-%E9%BB%91@2x-1.jpeg',
};
const ACTION_2 = {
  url: 'https://res.insta360.com/static/90896a0828e6b4c0e11c4477b5bfc908/03@2x.jpeg',
  urlL: 'https://res.insta360.com/static/8e9c9909c0b183ec7b598667b5ebfe95/03.jpeg',
  url_m: 'https://res.insta360.com/static/90896a0828e6b4c0e11c4477b5bfc908/03@2x.jpeg',
  url_s: 'https://res.insta360.com/static/a0a3a0171223f4ab2862b5ecda0a4166/03@2x-1.jpeg',
};
const ACTION_3 = {
  url: 'https://res.insta360.com/static/1d068ef07a307051c5063811f31e4f77/04@2x.jpeg',
  urlL: 'https://res.insta360.com/static/a3f3f9813b28de49e239b7b0189bcfc8/04.jpeg',
  url_m: 'https://res.insta360.com/static/1d068ef07a307051c5063811f31e4f77/04@2x.jpeg',
  url_s: 'https://res.insta360.com/static/c84c01b3f4c4df4cf3cc96d9765cdc32/04@2x-1.jpeg',
};

const ACTION_4 = {
  url: 'https://res.insta360.com/static/b745cdd460c646d606bf1d7c19d826f6/05@2x.jpeg',
  urlL: 'https://res.insta360.com/static/671f2732c2f17bf21f6408383546934d/05.jpeg',
  url_m: 'https://res.insta360.com/static/b745cdd460c646d606bf1d7c19d826f6/05@2x.jpeg',
  url_s: 'https://res.insta360.com/static/3a023927ae763745377e436bb87c080c/05@2x-1.jpeg',
};
const CREATOR_WHITE_1 = {
  url: 'https://res.insta360.com/static/af1d4e0f00006c0135cad730c5797a7d/01@2x.jpeg',
  urlL: 'https://res.insta360.com/static/f0a014909cfd179dc9ba65deb243c595/01.jpeg',
  url_m: 'https://res.insta360.com/static/af1d4e0f00006c0135cad730c5797a7d/01@2x.jpeg',
  url_s: 'https://res.insta360.com/static/c2deb0f2dc99e22f037dfcde6eb0d4c5/01@2x-1.jpeg',
};
const CREATOR_BLACK_1 = {
  url: 'https://res.insta360.com/static/7ece94d7ad48c6cf4fb679950644c3cd/02-%E9%BB%91@2x.jpeg',
  urlL: 'https://res.insta360.com/static/432099f5f5922523f143c28adca5aa13/02-%E9%BB%91.jpeg',
  url_m: 'https://res.insta360.com/static/7ece94d7ad48c6cf4fb679950644c3cd/02-%E9%BB%91@2x.jpeg',
  url_s: 'https://res.insta360.com/static/0ec3e433eee7163f4e3afa89176478ed/02-%E9%BB%91@2x-1.jpeg',
};
const CREATOR_2 = {
  url: 'https://res.insta360.com/static/cbdec8a6de06444b9b5762712d4b53cb/03@2x.jpeg',
  urlL: 'https://res.insta360.com/static/122189cde3248fcacb21c10ee1ce4712/03.jpeg',
  url_m: 'https://res.insta360.com/static/cbdec8a6de06444b9b5762712d4b53cb/03@2x.jpeg',
  url_s: 'https://res.insta360.com/static/7af5a022495bf7a993e6ff89157cdf74/03@2x-1.jpeg',
};
const CREATOR_3 = {
  url: 'https://res.insta360.com/static/e599197aced20240b3a1110d01fb7998/04@2x.jpeg',
  urlL: 'https://res.insta360.com/static/b037e88f459a9f1e2b05f9765e753da4/04.jpeg',
  url_m: 'https://res.insta360.com/static/e599197aced20240b3a1110d01fb7998/04@2x.jpeg',
  url_s: 'https://res.insta360.com/static/5da7e5bd7a2ec0ba82880444756fd367/04@2x-1.jpeg',
};
const CREATOR_4 = {
  url: 'https://res.insta360.com/static/cfc4c96e8ba759effb0b408785be02ae/05@2x.jpeg',
  urlL: 'https://res.insta360.com/static/6e50b2057e6f5086108b0af011a5075e/05.jpeg',
  url_m: 'https://res.insta360.com/static/cfc4c96e8ba759effb0b408785be02ae/05@2x.jpeg',
  url_s: 'https://res.insta360.com/static/1fea3a05d4f1e8dbdfa74ff8e70b0194/05@2x-1.jpeg',
};
const WATER_WHITE_1 = {
  url: 'https://res.insta360.com/static/1fc951db9e5b5ed701a642fad1b5bc2f/01@2x.jpeg',
  urlL: 'https://res.insta360.com/static/96e623c4089c57bfe6a325cf7ccd1a95/01.jpeg',
  url_m: 'https://res.insta360.com/static/1fc951db9e5b5ed701a642fad1b5bc2f/01@2x.jpeg',
  url_s: 'https://res.insta360.com/static/7940f5c359ba90b37675b5586d7f58cc/01@2x-1.jpeg',
};
const WATER_BLACK_1 = {
  url: 'https://res.insta360.com/static/8438b773aa002d64be94db18740d5b87/02-%E9%BB%91@2x.jpeg',
  urlL: 'https://res.insta360.com/static/d1d585c49f6d26de4abbb1617f8fa36d/02-%E9%BB%91.jpeg',
  url_m: 'https://res.insta360.com/static/8438b773aa002d64be94db18740d5b87/02-%E9%BB%91@2x.jpeg',
  url_s: 'https://res.insta360.com/static/119a806f673f21faf0fad288b91daff3/02-%E9%BB%91@2x-1.jpeg',
};
const WATER_2 = {
  url: 'https://res.insta360.com/static/823ab5888fa3e8f196bd113dac735c86/03@2x.jpeg',
  urlL: 'https://res.insta360.com/static/dfd37993ecdb0deedd7008be469853ee/03.jpeg',
  url_m: 'https://res.insta360.com/static/823ab5888fa3e8f196bd113dac735c86/03@2x.jpeg',
  url_s: 'https://res.insta360.com/static/4d935f26575557b97279a3c5041050a8/03@2x-1.jpeg',
};
const WATER_3 = {
  url: 'https://res.insta360.com/static/e293b92def872673f54ad12993141175/04@2x.jpeg',
  urlL: 'https://res.insta360.com/static/716a5eafdb1565843c51b1ccd6426df6/04.jpeg',
  url_m: 'https://res.insta360.com/static/e293b92def872673f54ad12993141175/04@2x.jpeg',
  url_s: 'https://res.insta360.com/static/99664403b4bccac317a5a47a2afcdf24/04@2x-1.jpeg',
};

const resourcesMapperJP = new Map([
  [3125, [STANDARD_WHITE_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard white
  [3135, [STANDARD_WHITE_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard white
  [3120, [STANDARD_BLACK_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard black
  [3130, [STANDARD_BLACK_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard black
  [3121, [FAMILY_BLACK_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family black
  [3131, [FAMILY_BLACK_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family black
  [3126, [FAMILY_WHITE_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family white
  [3136, [FAMILY_WHITE_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family white
  [3469, [ULTIMATE_BLACK_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate black
  [3470, [ULTIMATE_BLACK_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate black
  [3471, [ULTIMATE_WHITE_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate white
  [3472, [ULTIMATE_WHITE_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate white
  [3122, [ACTION_BLACK_1, ACTION_2, ACTION_3, ACTION_4]], // action black
  [3132, [ACTION_BLACK_1, ACTION_2, ACTION_3, ACTION_4]], // action black
  [3127, [ACTION_WHITE_1, ACTION_2, ACTION_3, ACTION_4]], // action white
  [3137, [ACTION_WHITE_1, ACTION_2, ACTION_3, ACTION_4]], // action white
  [3478, [CREATOR_BLACK_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator black
  [3479, [CREATOR_BLACK_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator black
  [3480, [CREATOR_WHITE_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator white
  [3481, [CREATOR_WHITE_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator white
  [3123, [WATER_BLACK_1, WATER_2, WATER_3]], // water black
  [3133, [WATER_BLACK_1, WATER_2, WATER_3]], // water black
  [3128, [WATER_WHITE_1, WATER_2, WATER_3]], // water white
  [3138, [WATER_WHITE_1, WATER_2, WATER_3]], // water white
]);

export default resourcesMapperJP;
